import { EMPTY_LIST } from '../../../../../constants/common'
import {
  APPLICANT_COMPARISON_STAGES,
  APPLICANT_STAGE,
} from '../../../../RentalPortalApplicant'

import {
  APPLICANT_COMPARISON_COLUMN_PREFIX,
  APPLICANT_COMPARISON_COLUMN_WIDTH,
  APPLICANT_COMPARISON_LABEL_COLUMN,
  APPLICANT_COMPARISON_LABEL_COLUMN_WIDTH,
  APPLICANT_COMPARISON_MIN_CANDIDATES,
  APPLICANT_COMPARISON_POSITION_ALPHABET,
  APPLICANT_COMPARISON_ROWS,
  APPLICANT_COMPARISON_STATE,
} from './RentalPortalApplicantComparison.constants'

function getApplicantComparisonPosition(index) {
  return APPLICANT_COMPARISON_POSITION_ALPHABET[index] ?? String(index + 1)
}

export function getApplicantComparisonItems(response) {
  return response?.items ?? EMPTY_LIST
}

export function getApplicantComparisonState({ hasError, isInitiated, items }) {
  if (hasError) {
    return APPLICANT_COMPARISON_STATE.error
  }

  if (!isInitiated) {
    return APPLICANT_COMPARISON_STATE.loading
  }

  return items.length > 0
    ? APPLICANT_COMPARISON_STATE.grid
    : APPLICANT_COMPARISON_STATE.empty
}

export function getApplicantComparisonColumnName(applicantId) {
  return `${APPLICANT_COMPARISON_COLUMN_PREFIX}${applicantId}`
}

export function getApplicantComparisonColumns({ items, labelClassName, t }) {
  const columns = items.map((item, index) => [
    getApplicantComparisonColumnName(item.id),
    {
      index: index + 1,
      name: getApplicantComparisonColumnName(item.id),
      ordering_field: null,
      title: t('RentalPortal.ApplicantComparisonColumnKey', {
        position: getApplicantComparisonPosition(index),
      }),
      visible: true,
      width: APPLICANT_COMPARISON_COLUMN_WIDTH,
    },
  ])

  return Object.fromEntries([
    [
      APPLICANT_COMPARISON_LABEL_COLUMN,
      {
        className: labelClassName,
        index: 0,
        name: APPLICANT_COMPARISON_LABEL_COLUMN,
        ordering_field: null,
        title: null,
        visible: true,
        width: APPLICANT_COMPARISON_LABEL_COLUMN_WIDTH,
      },
    ],
    ...columns,
  ])
}

export function getApplicantComparisonRows() {
  return APPLICANT_COMPARISON_ROWS.map(id => ({ id }))
}

export function getApplicantComparisonByColumn(items) {
  return new Map(
    items.map(item => [getApplicantComparisonColumnName(item.id), item])
  )
}

export function getIsApplicantComparisonSelected(applicant) {
  return Boolean(applicant?.is_selected)
}

export function getHasApplicantComparisonSelection(items) {
  return items.some(getIsApplicantComparisonSelected)
}

export function getHasApplicantComparisonCandidates(items) {
  const list = items ?? EMPTY_LIST

  return (
    list.length === 0 ||
    list.filter(item => APPLICANT_COMPARISON_STAGES.includes(item.stage))
      .length >= APPLICANT_COMPARISON_MIN_CANDIDATES
  )
}

export function getIsApplicantComparisonScreeningStage(applicant) {
  return applicant?.stage === APPLICANT_STAGE.screening
}

export function getIsApplicantComparisonSelectable(applicant) {
  return Boolean(
    getIsApplicantComparisonScreeningStage(applicant) &&
    applicant.permissions?.can_select
  )
}

export function getIsApplicantComparisonEmpty(state) {
  return state === APPLICANT_COMPARISON_STATE.empty
}

export function getIsApplicantComparisonError(state) {
  return state === APPLICANT_COMPARISON_STATE.error
}
